module.exports = __webpack_public_path__ + "img/catalogInit.59689ffa.svg";